import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ProductsService } from '../products.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { ActivatedRoute, Router } from '@angular/router'
import { CategoriesService } from '../../categories/categories.service'
import { MatChipInputEvent } from '@angular/material/chips'
import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ViewChild } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { HelpersService } from 'src/app/helpers.service'
import { ShopifyService } from 'src/app/integrations/shopify/shopify.service'
@Component({
  selector: 'new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit {
  panelOpen = true
  attributeOpen = true
  variationOpen = true
  tagsOpen = true
  CodeOpen = true
  varDescOpen = false
  productProgress = false
  mobile = false
  productDescription: any
  selectedFile: File | null = null
  imageUrl: string[] = []
  documentUrls: { name: string, url: string }[] = []
  showAllDocuments: boolean = false;
  showQrTable = false
  showPdfInput = false
  tempDocumentFiles: File[] = []
  selectedToggle: 'none' | 'qr' | 'pdf' = 'none'
  toggleLocked = false

  // Custom dropdown states
  dropdownOpen: { [key: string]: boolean } = {}
  categoryDropdownOpen = false
  subCategoryDropdownOpen = false
  codeTypeDropdownSimple: boolean[] = []
  codeTypeDropdownVariation: boolean[][] = []

  readonly deliveryUnitOptions = [
    { value: 'minutes', label: 'Minutes' },
    { value: 'hours', label: 'Hours' },
    { value: 'days', label: 'Days' },
    { value: 'weeks', label: 'Weeks' },
  ]
  readonly userTypeOptions = [
    { value: 'customer', label: 'Customer' },
    { value: 'merchant', label: 'Merchant' },
  ]
  readonly imageSizeOptions = [
    { value: 'auto', label: 'Auto' },
    { value: 'custom', label: 'Custom' },
  ]
  readonly codeTypeOptions = [
    { value: 'qr', label: 'QR' },
    { value: 'barcode', label: 'Bar' },
    { value: 'code', label: 'Code' },
  ];
  showUploadProgress = false
  currentUploadName: string | null = null;
  currentUploadProgress: number = 0;
  dragOverDocs: boolean = false;
  showSizeChartUploadProgress = false
  showVarUploadProgress: any = []
  productIdFromRoute: any
  selectedSizeChartFile: File | null = null
  productForm: FormGroup
  productAttributes: any = []
  attributesModified = false
  editingAttrValue: { attrIndex: number; value: string } | null = null

  productVariations: any = []
  tags: { key: string; values: string[] }[] = []
  selectedCategory: any
  selectedSubCategory: any
  separatorKeysCodes = [ENTER]
  possibileVariations: any = []
  allowedSubcategories: any = []

  dragOver: boolean = false
  // True while a product image is being dragged to reorder, so the click that follows the drop doesn't open the file picker
  draggingImage: boolean = false
  @ViewChild(MatPaginator) paginator!: MatPaginator
  selectedTabIndex: number[] = []
  selectedTabIndexSimple = 0
  filteredCodes = new MatTableDataSource<{ value: string; used: boolean; codeType: string }>()
  filteredCodesVariation: MatTableDataSource<{ value: string; used: boolean; codeType: string }>[] = []
  newCode: string[] = []
  newCodeType: string[] = []
  newCodeSimple: string = ''
  newCodeTypeSimple: string = 'qr'

  // Flags for tracking async load state
  private categoriesLoaded = false
  private productLoaded = false
  private loadedProduct: any = null

  constructor(private cdr: ChangeDetectorRef, private formBuilder: FormBuilder, private productsService: ProductsService, private router: Router, public builderService: BuilderService, private route: ActivatedRoute, public categoriesService: CategoriesService, private toastr: ToastrService, private helpers: HelpersService, private shopifyService: ShopifyService) {
    this.productForm = this.createProductForm()
  }

  /**
   * Single source of truth for form structure and defaults.
   * When editing old products with missing fields, patchValue() will
   * automatically preserve these defaults for any missing properties.
   */
  private createProductForm(): FormGroup {
    return this.formBuilder.group({
      productName: ['', Validators.required],
      badge: [''],
      productType: ['simple'],
      userType: ['customer'],
      location: [''],
      productFormat: ['physical'],
      productDescription: [''],
      regularPrice: ['', Validators.required],
      salePrice: [''],
      productSKU: [''],
      imageUrl: [[]],
      codes: this.formBuilder.control<{ value: string; used: boolean; codeType: string }[]>([]),
      sizeChartUrl: [''],
      estimatedDeliveryTime: [''],
      estimatedDeliveryUnit: [[]],
      productStock: ['', Validators.required],
      productAttributes: [''],
      productVariations: [''],
      categoriesIds: [[]],
      subCategoriesIds: [[]],
      tags: [[]],
      date: [''],
      productDocumentUrls: [[]],
      imageSizeType: ['auto'],
      imageWidth: [''],
      imageHeight: [''],
      publish: [true],
      weightKg: [''],
      lengthCm: [''],
      widthCm: [''],
      heightCm: ['']
    })
  }

  /**
   * Normalizes backend data before patching the form.
   * Handles type conversions and ensures arrays are properly formatted.
   */
  private normalizeProductData(product: any): any {
    const normalized = { ...product }

    // Convert category IDs to strings
    if (normalized.categoriesIds) {
      normalized.categoriesIds = normalized.categoriesIds.map((id: any) => String(id))
    }
    if (normalized.subCategoriesIds) {
      normalized.subCategoriesIds = normalized.subCategoriesIds.map((id: any) => String(id))
    }

    // Ensure imageUrl is always an array
    if (typeof normalized.imageUrl === 'string') {
      normalized.imageUrl = normalized.imageUrl ? [normalized.imageUrl] : []
    }

    // Handle stock for legacy products
    if (!normalized.productStock) {
      normalized.productStock = normalized.stockManagement === false ? -1 : 0
    }

    normalized.regularPrice = normalized.regularPrice ? Number(normalized.regularPrice) : ''
    normalized.salePrice = normalized.salePrice ? Number(normalized.salePrice) : ''

    if (normalized.productVariations) {
      normalized.productVariations = normalized.productVariations.map((v: any) => ({
        ...v,
        regularPrice: v.regularPrice ? Number(v.regularPrice) : '',
        salePrice: v.salePrice ? Number(v.salePrice) : ''
      }))
    }

    return normalized
  }

  /**
   * Populates the form when editing an existing product.
   * Uses patchValue() so missing fields automatically keep their defaults.
   */
  private populateFormForEdit(product: any): void {
    // Normalize the data first
    const normalized = this.normalizeProductData(product)

    // patchValue() only updates controls that exist AND have values in the source object
    // Missing fields in `normalized` will keep their default values from createProductForm()
    this.productForm.patchValue(normalized)

    // Update regularPrice validator based on loaded product type
    this.updateRegularPriceValidator(normalized.productType || 'simple')

    // Set up QR codes table
    this.filteredCodes.data = this.productForm.get('codes')?.value || []
    this.filteredCodes.paginator = this.paginator
    if (this.filteredCodes?.data?.length > 0) {
      this.setToggle('qr')
    }

    // Handle tags (stored as object, displayed as array)
    if (product.tags) {
      this.tags = Object.entries(product.tags).map(([key, values]) => ({
        key,
        values: values as string[]
      }))
    }

    // Set component-level properties (not part of form)
    this.imageUrl = normalized.imageUrl || []
    this.productAttributes = product.productAttributes
    this.productVariations = product.productVariations
    this.productDescription = product.productDescription

    // Handle document URLs
    if (product.productDocumentUrls?.length > 0) {
      this.setToggle('pdf')
      this.documentUrls = product.productDocumentUrls
    }

    // Initialize attributes/variations if missing
    if (!this.productAttributes && !this.productVariations) {
      this.initAttributesandVariations()
    }

    // Set up category selection
    this.selectedCategory = this.categoriesService.findCategoryById(this.categoriesService.allCategories, product.categoriesIds)
    this.selectedSubCategory = this.categoriesService.findSubCategoryById(this.categoriesService.allCategories, product.subCategoriesIds)
    this.categoryChange(product.categoriesIds || [])

    this.initVariations()
    this.initiCodeForVariations()
    // Update total stock for variable products
    if (normalized.productType === 'variable') {
      this.updateVariationStockSum()
    }
      if (this.builderService.isStockManager) {
    this.disableNonStockFields();
  }
}
  /**
   * Disables all fields in the product form and re-enables only the stock field.
   *
   * This is used when the current user is a Stock Manager and should only
   * be allowed to modify the product stock quantity. All other product
   * fields remain disabled to prevent unintended edits.
   *
   * emitEvent is set to false to avoid triggering value/status change events
   * while toggling the form controls.
   */
    private disableNonStockFields(): void {
      // disable everything
      this.productForm.disable({ emitEvent: false });

      // enable ONLY what stock manager can edit
      this.productForm.get('productStock')?.enable({ emitEvent: false });
      this.productForm.get('productType')?.enable({ emitEvent: false });

    }
    /**
   * Initializes the editor configuration.
   *
   * If the logged-in user is a Stock Manager, the editor is switched
   * to `readonly` mode to prevent editing of rich text content.
   *
   * @param event - Editor initialization event containing the editor instance.
   */
    initEditor(event: any) {
      if (this.builderService.isStockManager) {
        event.editor.setMode('readonly');
      }
    }
    
  ngOnInit(): void {
    this.productIdFromRoute = this.route.snapshot.paramMap.get('productId')

    this.loadCategories()
    this.loadProduct()
    this.setupFormListeners()
    this.detectMobile()
  }

  // ─────────────────────────────────────────────────────────────
  // Initialization Methods
  // ─────────────────────────────────────────────────────────────

  private loadCategories(): void {
    this.categoriesService.getCategories().subscribe(() => {
      this.categoriesLoaded = true
      this.syncCategorySelection()
    })
  }

  private loadProduct(): void {
    if (!this.productIdFromRoute) return

    this.productsService.getProduct(this.productIdFromRoute).subscribe((product: any) => {
      this.loadedProduct = product
      this.productLoaded = true
      this.populateFormForEdit(product)
      this.syncCategorySelection()
    })
  }

  private setupFormListeners(): void {
    this.productForm.get('productType')?.valueChanges.subscribe((value) => {
      if (value === 'variable' && this.documentUrls.length > 0) {
        this.documentUrls = []
      }
      this.updateRegularPriceValidator(value)
    })
  }

  /**
   * Updates the regularPrice and productStock validators based on product type.
   * For variable products, price and stock are set per variation, so they're not required at product level.
   */
  private updateRegularPriceValidator(productType: string): void {
    const regularPriceControl = this.productForm.get('regularPrice')
    const productStockControl = this.productForm.get('productStock')

    if (productType === 'variable') {
      regularPriceControl?.clearValidators()
      productStockControl?.clearValidators()
    } else {
      regularPriceControl?.setValidators(Validators.required)
      productStockControl?.setValidators(Validators.required)
    }
    regularPriceControl?.updateValueAndValidity()
    productStockControl?.updateValueAndValidity()
  }

  private detectMobile(): void {
    if (window.screen.width <= 768) {
      this.mobile = true
    }
  }

  /**
   * Syncs category/subcategory selection when BOTH product and categories are ready.
   * Safe to call multiple times (idempotent) - only runs when both are loaded.
   */
  private syncCategorySelection(): void {
    if (!this.categoriesLoaded || !this.productLoaded || !this.loadedProduct) return

    // Supabase returns all linked IDs (parent + sub) in categoriesIds — split them using the tree
    const allIds = this.loadedProduct.categoriesIds || []

    if (!allIds.length) return

    this.selectedCategory = this.categoriesService.findCategoryById(this.categoriesService.allCategories, allIds)
    this.selectedSubCategory = this.categoriesService.findSubCategoryById(this.categoriesService.allCategories, allIds)

    const parentIds = this.selectedCategory.map((c: any) => String(c.categoryId))
    const subIds = (this.selectedSubCategory as any[]).map((s: any) => String(s.subCategoryId))

    this.categoryChange(parentIds)
    this.productForm.patchValue({ categoriesIds: parentIds, subCategoriesIds: subIds })
  }

 
  initiCodeForVariations() {
    this.productVariations?.forEach((item: any, index: number) => this.filterQrCodesByTab(0, index))
  }

  /**
 * Purpose:
 * Ensures that each product variation only keeps valid attribute values
 * that still exist in the current `productAttributes` list.
 *
 * Why it's needed:
 * When a user deletes or edits product attributes (e.g., removes “red” from Color),
 * some variations may still contain outdated values (like "red,100").
 * This code removes those invalid values before saving.
 *
 * How it works:
 * 1. It first collects **all valid attribute values** from `productAttributes`
 *    (splitting by commas in case a single field has multiple values like "red,blue").
 * 2. Then, it loops through each variation in `productVariations`.
 * 3. For each variation, it:
 *    - Splits its `values` string into an array (e.g., "red,100" → ["red", "100"])
 *    - Filters out any value that is **not found** in the valid attributes list.
 *    - Joins the remaining valid ones back into a string.
 * 4. The cleaned-up list replaces the old `productVariations` array.
 *
 * Example:
 * productAttributes = [{ name: 'Color', value: 'blue' }, { name: 'Size', value: '100' }]
 * productVariations = [{ values: 'red,100' }]
 *
 * After cleanup → [{ values: '100' }]
 * ("red" removed because it no longer exists in attributes)
 */

  private cleanVariationValues(productFormVal: any): any {
    if (!productFormVal.productVariations || productFormVal.productVariations.length === 0) {
      return productFormVal
    }

    // Collect all valid attribute values (split by commas)
    const currentAttrValues = this.productAttributes.flatMap((a: any) =>
      (a.value || '')
        .split(',')
        .map((v: string) => v.trim())
        .filter(Boolean)
    )

    // Clean each variation's values based on existing attributes
    productFormVal.productVariations = productFormVal.productVariations.map((variation: any) => {
      const values = (variation.values || '')
        .split(',')
        .map((v: string) => v.trim())
        .filter(Boolean)
      const cleanedValues = values.filter((v: any) => currentAttrValues.includes(v))
      return { ...variation, values: cleanedValues.join(',') }
    })

    return productFormVal
  }

  onSubmit = () => {
    this.productProgress = true

    // Update stock sum for variable products before capturing form value
    if (this.productForm.get('productType')?.value === 'variable') {
      this.updateVariationStockSum()
    }

    let productFormVal = this.builderService.isStockManager ? this.productForm.getRawValue() : this.productForm.value
    productFormVal.productName = productFormVal.productName.trim()
    productFormVal.productAttributes = this.productAttributes
    productFormVal.productVariations = this.productVariations
    productFormVal.productDescription = this.productDescription
    productFormVal = this.cleanVariationValues(productFormVal);
    productFormVal.categoriesIds = this.categoriesService.getCategoryIdFromCategories(this.selectedCategory, 'category')
    productFormVal.imageUrl = this.imageUrl
    productFormVal.productDocumentUrls = this.documentUrls
    productFormVal.tags = this.tags.reduce((acc, tag) => {
      if (tag.key && tag.values.length > 0) {
        acc[tag.key] = tag.values
      }
      return acc
    }, {} as { [key: string]: string[] })
    const isVariable = productFormVal.productType === 'variable'
    if (productFormVal.productFormat === 'digital' && !isVariable) {
      this.updateProductStockSimple()
    }
    productFormVal.productStock = productFormVal.productStock ? Math.floor(Number(productFormVal.productStock)) : 0
    if (isVariable) {
      productFormVal.productVariations = productFormVal.productVariations.map((v: any) => ({
        ...v,
        stock: v.stock ? Math.floor(Number(v.stock)) : 0,
        regularPrice: v.regularPrice ? Number(v.regularPrice) : '',
        salePrice: v.salePrice ? Number(v.salePrice) : ''
      }))
    }
    productFormVal.regularPrice = productFormVal.regularPrice ? Number(productFormVal.regularPrice) : ''
    productFormVal.salePrice = productFormVal.salePrice ? Number(productFormVal.salePrice) : ''
    const variations = productFormVal.productVariations ?? []
    // For variable products, check all variations have price, stock, and values
    const hasEmptyFields =
      isVariable &&
      variations.some((v: { regularPrice: any; stock: any; values: string }) => {
        const priceEmpty = v.regularPrice === '' || v.regularPrice === null || v.regularPrice === undefined
        const stockEmpty = !v.stock
        const valuesEmpty = !v.values || v.values.trim() === ''
        return priceEmpty || stockEmpty || valuesEmpty
      })
    if (this.productForm.status === 'INVALID') {
      this.toastr.error('Please fill all the required fields')
      this.productProgress = false
      return
    }
    if (hasEmptyFields) {
      this.toastr.error('Please make sure that all variations have price, stock, and values')
      this.productProgress = false
      return
    }
    if (this.productIdFromRoute) {
      this.productsService.submitProduct(productFormVal, this.productIdFromRoute).subscribe((result: any) => {
        this.productProgress = false
        this.productsService.updateProductInCache(this.productIdFromRoute, productFormVal)
        this.shopifyService.pushProduct({ product_id: this.productIdFromRoute, shopify_id: this.loadedProduct?.external_id || null, ...productFormVal }).subscribe({
          error: (err: any) => console.error('Shopify sync failed:', err)
        })
        if (this.builderService.getTour()) {
          this.router.navigate(['/'])
        } else {
          this.router.navigate(['/products'])
        }
      })
    } else {
      productFormVal.date = this.helpers.getCurrentDateString()
      this.productsService.submitProduct(productFormVal).subscribe((result: any) => {
        this.productProgress = false
        const newProductId = result?.key || result?.id;
          this.productsService.addProductsToCache([{
            Id: newProductId,
            ...productFormVal
          }]);
          this.shopifyService.pushProduct({ product_id: newProductId, ...productFormVal }).subscribe({
            error: (err: any) => console.error('Shopify sync failed:', err)
          })
        if (this.builderService.getTour()) {
          this.router.navigate(['/'])
        } else {
          this.router.navigate(['/products'])
        }
      })
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault()
    this.dragOver = true
    this.dragOverDocs = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault()
    this.dragOver = false
    this.dragOverDocs = false;
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault()

    const files = event.dataTransfer?.files
    if (!files || files.length === 0) return

    const remainingSlots = 5 - this.imageUrl.length

    if (remainingSlots <= 0) {
      alert('You can only upload up to 5 images.')
      return
    }

    if (files.length > remainingSlots) {
      alert(`Only ${remainingSlots} more image(s) can be uploaded.`)
    }

    const selectedFiles = Array.from(files).slice(0, remainingSlots)

    selectedFiles.forEach((file) => {
      const fakeEvent = { target: { files: [file] } }
      this.onFileSelected(fakeEvent)
    })
  }

  onFileSelected(event: any, type = 'simple', index = 0) {
    const files: FileList = event.target.files

    if (!files || files.length === 0) {
      console.error('No files selected.')
      return
    }

    if (!this.imageUrl) {
      this.imageUrl = []
    }

    const remainingSlots = 5 - this.imageUrl.length

    if (remainingSlots <= 0) {
      alert('You can only upload up to 5 images.')
      return
    }

    if (files.length > remainingSlots) {
      alert(`Only 5 images can be uploaded.`)
      return
    }

    const selectedFiles = Array.from(files).slice(0, remainingSlots)

    this.showUploadProgress = true

    selectedFiles.forEach((file) => {
      this.builderService.uploadImage(file, this.builderService.selectedProject, 'products')?.subscribe((response) => {
        this.imageUrl.push(response)
        this.showUploadProgress = false
      })
    })
  }

  onVarFileSelected(event: any, type = 'simple', index: any) {
    this.selectedFile = event.target.files[0] as File
    if (!this.selectedFile) {
      console.error('No file selected.')
      return
    }
    this.showVarUploadProgress[index] = true
    this.builderService.uploadImage(this.selectedFile, this.builderService.selectedProject, 'products')?.subscribe((response) => {
      if (type == 'variation') {
        this.variationChange('image', response, index, '')
      } else {
        this.imageUrl.push(response)
      }
      this.showVarUploadProgress[index] = false
    })
  }
  removeImg(index: number) {
    this.imageUrl.splice(index, 1)
  }
  removeFromImgArr(index: number) {
    this.imageUrl.splice(index, 1)
  }
  editImg(event: any, index: number) {
    this.showUploadProgress = true
    this.selectedFile = event.target.files[0] as File
    this.builderService.uploadImage(this.selectedFile, this.builderService.selectedProject, 'products')?.subscribe((response) => {
      this.imageUrl[index] = response
    })
    this.showUploadProgress = false
  }

  // Thumbnails dragged up/down. List indexes are offset by 1 because imageUrl[0] is the main image.
  reorderThumbnail(event: { previousIndex: number; currentIndex: number }) {
    const [moved] = this.imageUrl.splice(event.previousIndex + 1, 1)
    this.imageUrl.splice(event.currentIndex + 1, 0, moved)
  }

  // A thumbnail dropped on the main image swaps places with it.
  makeMainImage(event: { item: { data: number } }) {
    const index = event.item.data
    if (!index || !this.imageUrl[index]) return
    ;[this.imageUrl[0], this.imageUrl[index]] = [this.imageUrl[index], this.imageUrl[0]]
  }

  onImageDragEnded() {
    // Reset after the click that follows pointerup has been handled
    setTimeout(() => (this.draggingImage = false))
  }

  removeVariationImg(index: number) {
    this.productVariations[index]['image'] = ''
  }

  addAttr = () => {
    this.initVariations()
    this.productAttributes.push({
      name: '',
      value: ''
    })
    this.attributesModified = true
  }

  initAttributesandVariations = () => {
    this.productAttributes = []
    this.productVariations = []
  }

  initVariations = () => {
    this.possibileVariations = []
    for (const key in this.productAttributes) {
      if (Object.prototype.hasOwnProperty.call(this.productAttributes, key)) {
        const element = this.productAttributes[key]
        this.possibileVariations.push(this.splitAndTrimValues(element.value))
      }
    }
  }

  public splitAndTrimValues(value: string): string[] {
    if (!value) return []

    return value.split(',').map((item) => item.trim())
  }

  removeAttr = (index: number) => {
    this.productAttributes.splice(index, 1)
    this.editingAttrValue = null
    this.attributesModified = true
    if (this.productAttributes.length === 0) {
      this.productVariations = []
      this.possibileVariations = []
      return
    }
    this.initVariations()
  }

  addVar = () => {
    this.productVariations.push({
      values: '',
      image: '',
      stock: '',
      regularPrice: '',
      salePrice: '',
      sku: '',
      codes: [] as { value: string; used: boolean; codeType: string }[]
    })
  }

  removeVar = (index: number) => {
    this.productVariations.splice(index, 1)
  }

  attributeChange = (name: string, event: any, index: number) => {
    let data = event.currentTarget.value
    this.attributesModified = true
    if (name === 'attrName') {
      this.productAttributes[index].name = data
    } else if (name === 'attrValue') {
      // Split the input string into an array of values
      let valuesArray = this.splitAndTrimValues(data)

      // Trim each value and join them back with a space and comma
      data = valuesArray.map((value: string) => value.trim()).join(', ')

      this.productAttributes[index].value = data
      this.initVariations()
    }
  }

  variationChange = (name: string, value: any, index: number, variationValues: any) => {
    if (name == 'values') {
      if (!this.productVariations[index][name]) {
        this.productVariations[index][name] = ''
      }
      // check the value across possible values to replace it, if nothing can be changed then concat the new value to the string
      // otherwise just add it
      if (this.productVariations[index][name]) {
        this.productVariations[index][name] = this.variationAdjuster(value, variationValues)
        this.productVariations[index][name] += ',' + value

        // Split the input string into an array of words
        let words = this.splitAndTrimValues(this.productVariations[index][name])

        // Use Set to get unique values and convert it back to an array
        let uniqueWords = Array.from(new Set(words))

        // Convert the unique array back to a string
        this.productVariations[index][name] = uniqueWords.join(',')
      } else {
        this.productVariations[index][name] = value.toString()
      }
    } else {
      this.productVariations[index][name] = value
    }
  }

  /**
   * Calculates the sum of all variation stocks and updates productStock.
   * Only applies to variable products.
   */
  private updateVariationStockSum(): void {
    if (this.productForm.get('productType')?.value !== 'variable') return

    const totalStock = this.productVariations.reduce((sum: number, variation: any) => {
      const stock = parseInt(variation.stock, 10)
      return sum + (isNaN(stock) ? 0 : stock)
    }, 0)

    this.productForm.get('productStock')?.setValue(totalStock)
  }

  variationLookup = (variations: string, variationLookup: any) => {
    const variationsArray = this.splitAndTrimValues(variations)
    return variationsArray.filter((element) => variationLookup.includes(element))[0]
  }

  /**
   * 
   * Example for how this works
   * selected values =  ["large", "red"]

      possible values = [ "large", " small"] ["red", "blue"]

      The following function takes a selected value
      example variationAdjuster("small");

      the selected_values array will be ["small","red"]

      the function replaced the large with small since both combinations can replace each other
   * @param newValue the new value selected in the variation
   * @param variationValues all the values in the variation
   * 
   * return true: means value adjusted
   * return false: means there is nothing to change
   */
  variationAdjuster(newValue: any, variationValues: any) {
    // Define the possible value combinations

    // Iterate through each possible value combination
    for (const combination of this.possibileVariations) {
      // Check if the newValue is in the combination
      if (combination.includes(newValue)) {
        let arrayVarValues = this.splitAndTrimValues(variationValues)
        // Replace the old value with the new value
        arrayVarValues = arrayVarValues.map((value: any) => (combination.includes(value) ? newValue : value))
        variationValues = arrayVarValues.join(',')
      }
    }
    return variationValues
  }

  categoryChange = (value: string[]) => {
    this.selectedCategory = this.categoriesService.findCategoryById(this.categoriesService.allCategories, value)
    this.allowedSubcategories = []
    for (const category of this.selectedCategory) {
      if (!category.subcategories || category.subcategories.length == 0) {
        continue
      }
      for (const subcategory of category.subcategories) {
        this.allowedSubcategories.push(subcategory)
      }
    }
  }

  subCategoryChange = (value: string) => {
    this.selectedSubCategory = value
  }

  getVariationStock = (variation: any) => {
    if ((variation.stockManagement == false && variation.stock_status == 'instock') || (variation.stockManagement == true && !variation.stock)) {
      return -1
    } else if (variation.stock_status == 'outofstock' || (variation.stockManagement == true && variation.stock == 0)) {
      return 0
    } else {
      return variation.stock ? Math.floor(Number(variation.stock)) : 0
    }
  }

  onSizeChartSelected(event: any) {
    this.selectedSizeChartFile = event.target.files[0] as File
    if (!this.selectedSizeChartFile) {
      console.error('No file selected.')
      return
    }

    this.showSizeChartUploadProgress = true
    this.builderService.uploadImage(this.selectedSizeChartFile, this.builderService.selectedProject, 'size_charts').subscribe(
      (downloadURL) => {
        this.productForm.value.sizeChartUrl = downloadURL // Save the uploaded image URL
        this.showSizeChartUploadProgress = false
      },
      (error) => {
        console.error('Error uploading size chart:', error)
        this.showSizeChartUploadProgress = false
      }
    )
  }

  removeSizeChart() {
    this.productForm.value.sizeChartUrl = ''
  }

  addTagCategory(): void {
    this.tags.push({ key: '', values: [] })
  }

  // Remove a tag category
  removeTagCategory(index: number): void {
    this.tags.splice(index, 1)
  }

  // Add a value to a specific tag category
  addTagValue(event: MatChipInputEvent, index: number): void {
    const value = (event.value || '').trim().toLowerCase()
    if (value) {
      const values = this.tags[index].values
      if (!values.includes(value)) {
        values.push(value)
      } else {
        alert('This value is already added.')
      }
    }
    event.chipInput!.clear() // Clear the input field
  }

  // Remove a value from a specific tag category
  removeTagValue(index: number, value: string): void {
    const values = this.tags[index].values
    const valueIndex = values.indexOf(value)
    if (valueIndex >= 0) {
      values.splice(valueIndex, 1)
    }
  }

  // Update tag key
  updateTagKey(index: number, event: any): void {
    const key = event.target.value.trim()
    this.tags[index].key = key
  }

  placeholderArray(): number[] {
    const length = Array.isArray(this.imageUrl) ? this.imageUrl.length : 0

    const emptySlots = Math.max(0, 4 - Math.max(0, length - 1))

    return Array.from({ length: emptySlots })
  }

  // ============================================
  // Attribute Chip Methods (Variable Products)
  // ============================================

  /**
   * Get values array for an attribute at given index
   */
  getAttributeValues(index: number): string[] {
    const attr = this.productAttributes[index]
    if (!attr || !attr.value) return []
    return this.splitAndTrimValues(attr.value)
  }

  /**
   * Add a value from the chip input, or replace the value being edited in place
   */
  addAttributeValue(event: MatChipInputEvent, index: number): void {
    const value = (event.value || '').trim()
    const editedValue = this.editingAttrValue?.attrIndex === index ? this.editingAttrValue.value : null
    if (editedValue !== null) this.editingAttrValue = null
    event.chipInput!.clear()

    // Empty or unchanged input just ends the edit
    if (!value || value === editedValue) return

    const values = this.getAttributeValues(index)
    if (values.includes(value)) {
      // alert('This value is already added.')
      return
    }

    if (editedValue === null) {
      values.push(value)
    } else {
      values[values.indexOf(editedValue)] = value
      this.renameVariationValue(index, editedValue, value)
    }
    this.productAttributes[index].value = values.join(', ')
    this.attributesModified = true
    this.initVariations()
  }

  /**
   * Remove a value from an attribute
   */
  removeAttributeValue(index: number, valueToRemove: string): void {
    if (this.isEditingAttributeValue(index, valueToRemove)) {
      this.editingAttrValue = null
    }
    const currentValues = this.getAttributeValues(index)
    const valueIndex = currentValues.indexOf(valueToRemove)
    if (valueIndex >= 0) {
      currentValues.splice(valueIndex, 1)
      this.productAttributes[index].value = currentValues.join(', ')
      this.attributesModified = true
      this.initVariations()
    }
  }

  /**
   * Load a chip's value into the attribute input so it can be edited in place
   */
  startAttributeValueEdit(index: number, value: string, input: HTMLInputElement): void {
    if (this.builderService.isStockManager) return
    this.editingAttrValue = { attrIndex: index, value }
    input.value = value
    input.focus()
    input.select()
  }

  cancelAttributeValueEdit(input: HTMLInputElement): void {
    if (!this.editingAttrValue) return
    this.editingAttrValue = null
    input.value = ''
  }

  isEditingAttributeValue(index: number, value: string): boolean {
    return this.editingAttrValue?.attrIndex === index && this.editingAttrValue.value === value
  }

  /**
   * Rename the value inside existing variation keys so their price, stock, SKU and codes
   * carry over on the next generateVariations() instead of being reset to defaults.
   */
  private renameVariationValue(attrIndex: number, oldValue: string, newValue: string): void {
    // Keys hold one value per valid attribute, in order (see generateVariations)
    const position = this.productAttributes.slice(0, attrIndex).filter(this.isValidAttribute).length

    for (const variation of this.productVariations || []) {
      const parts = this.splitAndTrimValues(variation.values)
      if (parts[position] !== oldValue) continue
      parts[position] = newValue
      variation.values = parts.join(',')
    }
  }

  private isValidAttribute = (attr: { name: string; value: string }): boolean => !!attr.name?.trim() && !!attr.value?.trim()

  /**
   * Check if there are unsaved valid attributes (at least one with name and value, and dirty)
   */
  hasValidAttributes(): boolean {
    const hasValid = this.productAttributes?.some((attr: { name: string; value: string }) => attr.name?.trim() !== '' && attr.value?.trim() !== '')
    return hasValid && this.attributesModified
  }

  /**
   * Save attributes and generate variations
   */
  saveAttributes(): void {
    if (!this.productAttributes.some(this.isValidAttribute)) {
      alert('Please add at least one attribute with name and values.')
      return
    }

    // Generate all possible variation combinations
    this.generateVariations()

    // Mark as saved (no unsaved changes)
    this.attributesModified = false
  }

  /**
   * Generate all possible variation combinations from attributes
   */
  private generateVariations(): void {
    const attributeValues = this.productAttributes
      .filter(this.isValidAttribute)
      .map((attr: { name: string; value: string }) => this.splitAndTrimValues(attr.value))

    if (attributeValues.length === 0) {
      this.productVariations = []
      return
    }

    // Build a map of existing variations keyed by their values string
    const existingMap = new Map<string, any>()
    for (const variation of this.productVariations || []) {
      if (variation.values) {
        existingMap.set(variation.values, variation)
      }
    }

    // Generate cartesian product of all attribute values
    const combinations = this.cartesianProduct(attributeValues)

    // Create variation objects, preserving existing data for old variations
    this.productVariations = combinations.map((combo: string[]) => {
      const key = combo.join(',')
      const existing = existingMap.get(key)
      if (existing) {
        return existing
      }
      return {
        values: key,
        image: '',
        stock: 10,
        regularPrice: '100',
        salePrice: '',
        sku: '',
        publish: true,
        selected: false,
        codes: [] as { value: string; used: boolean; codeType: string }[]
      }
    })
  }

  /**
   * Calculate cartesian product of arrays
   */
  private cartesianProduct(arrays: string[][]): string[][] {
    if (arrays.length === 0) return [[]]
    return arrays.reduce(
      (acc, curr) => acc.flatMap((x) => curr.map((y) => [...x, y])),
      [[]] as string[][]
    )
  }

  // ============================================
  // Variations Table Methods
  // ============================================

  /**
   * Get display name for a variation (e.g., "Small / Red")
   */
  getVariationName(variation: any): string {
    if (!variation.values) return 'Variation'
    const values = this.splitAndTrimValues(variation.values)
    return values.join(' / ')
  }

  /**
   * Get attributes text for a variation (e.g., "size: small / color: red")
   */
  getVariationAttributesText(variation: any): string {
    if (!variation.values) return ''
    const values = this.splitAndTrimValues(variation.values)

    const parts = values.map((value: string, index: number) => {
      const attrName = this.productAttributes[index]?.name?.toLowerCase() || `attr${index + 1}`
      return `${attrName}: ${value}`
    })

    return parts.join(' / ')
  }

  /**
   * Returns `true` when the current product is “simple”
   * (i.e. not a variation group). Used to branch UI logic quickly.
   */
  private isSimple(): boolean {
    return this.productForm.value.productType === 'simple'
  }

  /**
   * Returns `true` when the current product is “digital”.
   * Digital products have QR-codes and a numeric stock value.
   */
  private isDigital(): boolean {
    return this.productForm.value.productFormat === 'digital'
  }

  /**
   * Counts how many codes in an array are **available**
   * (not used ✕ and not already tied to an order).
   */
  private calcStock(codes: { used: boolean; order_id?: any }[]): number {
    return codes.filter((qr) => !qr.used && !qr.order_id).length
  }

  /**
   * Filters a list of codes based on the active tab:
   * 0 → all, 1 → used, 2 → unused.
   */
  private filterCodesByTab(tab: number, codes: { value: string; used: boolean; codeType: string }[]): { value: string; used: boolean; codeType: string }[] {
    switch (tab) {
      case 1:
        return codes.filter((qr) => qr.used)
      case 2:
        return codes.filter((qr) => !qr.used)
      default:
        return codes
    }
  }

  /* -----------------------------------------------------------------------
   *  📜 Public / private API (optimised internals, original names)
   * -------------------------------------------------------------------- */

  /**
   * Returns the master QR-code array—either from the simple product
   * or from the requested variation index.
   */
  private getCodes(index?: number): { value: string; used: boolean; codeType: string }[] {
    return this.isSimple() ? this.productForm.get('codes')?.value ?? [] : this.productVariations[index!]?.codes ?? []
  }

  /**
   * Writes a QR-code list back to form or variation,
   * then refreshes stock and table views.
   */
  private setCodes(codes: { value: string; used: boolean; codeType: string }[], index?: number): void {
    if (this.isSimple()) {
      this.productForm.get('codes')?.setValue(codes)
      this.filteredCodes.data = codes
      this.updateProductStockSimple()
      this.onTabChange(this.selectedTabIndexSimple)
    } else {
      this.productVariations[index!].codes = codes
      this.updateProductVarStock(index!)
    }
  }

  /**
   * Adds a freshly-typed QR value to the correct list.
   */
  addCode(index?: number): void {
    const raw = this.isSimple() ? this.newCodeSimple : this.newCode[index!]
    const type = this.isSimple() ? this.newCodeTypeSimple : this.newCodeType[index!] ?? 'qr'
    const value = raw?.trim()
    if (!value) return

    const existingCodes = this.getCodes(index)
    const isDuplicate = existingCodes.some((code) => code.value === value)
    if (isDuplicate) {
      alert('This Code already exists.')
      return
    }
    this.setCodes([...existingCodes, { value, used: false, codeType: type }], index)

    if (this.isSimple()) {
      this.newCodeSimple = ''
      this.newCodeTypeSimple = 'qr'
    } else {
      this.newCode[index!] = ''
      this.newCodeType[index!] = 'qr'
      this.filterQrCodesByTab(0, index)
    }
  }

  /**
   * Removes a code from any tab; translates the visible row index
   * back to the real index first.
   */
  removeCode(viewIdx: number, variationIdx?: number): void {
    const realIdx = this.resolveRealIndex(viewIdx, variationIdx)
    if (realIdx === -1) return

    const all = this.getCodes(variationIdx)
    all.splice(realIdx, 1)
    this.filterQrCodesByTab(0, variationIdx)
    this.setCodes(all, variationIdx)
  }

  /**
   * Toggles the “used” flag for a specific row, regardless of
   * which tab it’s currently shown in.
   */
  onToggleUsed(viewIdx: number, variationIdx?: number): void {
    const realIdx = this.resolveRealIndex(viewIdx, variationIdx)
    if (realIdx === -1) return

    const all = this.getCodes(variationIdx)
    const cur = all[realIdx]
    all[realIdx] = { ...cur, used: !cur.used }
    this.setCodes(all, variationIdx)
  }

  /**
   * Recomputes stock for a simple (non-variation) digital product.
   */
  private updateProductStockSimple(): void {
    if (!this.isDigital()) return
    const stock = this.calcStock(this.getCodes())
    this.productForm.get('productStock')?.setValue(stock)
  }

  /**
   * Recomputes stock for a specific variation of a digital product.
   */
  private updateProductVarStock(variationIdx: number): void {
    if (!this.isDigital()) return
    const stock = this.calcStock(this.getCodes(variationIdx))
    this.productVariations[variationIdx].stock = stock
  }

  /**
   * Handles tab clicks for the simple-product QR table.
   * Saves selected index, applies filter, then re-attaches paginator.
   */
  onTabChange(index: number): void {
    this.selectedTabIndexSimple = index
    this.filteredCodes.data = this.filterCodesByTab(index, this.getCodes())
  }

  /**
   * Central entry when **any** tab (simple or variation) changes.
   * Keeps track of selected index per context & updates datasource.
   */
  filterQrCodesByTab(tabIdx: number, variationIdx?: number): void {
    const filtered = this.filterCodesByTab(tabIdx, this.getCodes(variationIdx))

    if (this.isSimple()) {
      this.filteredCodes.data = filtered
      this.selectedTabIndexSimple = tabIdx
      setTimeout(() => (this.filteredCodes.paginator = this.paginator))
      return
    }
    if (variationIdx == null) return
    this.selectedTabIndex[variationIdx] = tabIdx
    Promise.resolve().then(() => {
      const variationDataSource = this.ensureVariationDS(variationIdx)
      variationDataSource.data = filtered
      this.cdr.detectChanges()
    })
  }

  private ensureVariationDS(idx: number) {
    if (!this.filteredCodesVariation[idx]) {
      this.filteredCodesVariation[idx] = new MatTableDataSource<{ value: string; used: boolean; codeType: string }>()
    }
    return this.filteredCodesVariation[idx]
  }

  /**
   * Quick helper to switch between physical / digital format.
   */
  selectProductFormat(format: 'physical' | 'digital'): void {
    this.productForm.get('productFormat')?.setValue(format)
  }

  /**
   * Converts a row index visible in a filtered table back to
   * its position in the underlying master array.
   */
  private resolveRealIndex(viewIdx: number, variationIdx?: number): number {
    const all = this.getCodes(variationIdx)
    const currentTab = this.isSimple() ? this.selectedTabIndexSimple : this.selectedTabIndex[variationIdx!]

    const objInView = this.filterCodesByTab(currentTab, all)[viewIdx]
    return all.findIndex((c) => c === objInView)
  }

  /**
   * Updates the codeType for a specific row and persists.
   * @param realindex      index in the master list
   * @param variationIdx undefined for simple product, else the variation index
   * @param newType      'qr' | 'barcode' | 'code'
   */
  onCodeTypeChange(realindex: number, variationIdx: number | undefined, newType: string): void {
    const list = this.getCodes(variationIdx)
    if (!list[realindex]) return

    list[realindex] = { ...list[realindex], codeType: newType }
    this.setCodes(list, variationIdx)
  }
 /**
   * Toggles between QR table view and PDF document upload view.
   * Once one option is selected, it cannot be switched again unless the page is refreshed.
   *
   * @param option - 'qr' to show QR input table, 'pdf' to show document upload
   */
   setToggle(option: 'qr' | 'pdf') {
    if (this.toggleLocked) return

    this.selectedToggle = option
    this.showQrTable = option === 'qr'
    this.showPdfInput = option === 'pdf'

    this.toggleLocked = true
  }
  /**
   * Handles user-selected document files, validates type and count,
   * and uploads them to Firebase Storage.
   *
   * @param event - File input change event
   */
  onDocumentSelected(event: any) {
    const files: FileList = event.target.files
    if (!files || files.length === 0) {
      alert('No files selected.')
      return
    }

    const selectedFiles = Array.from(files)

    const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'application/rtf',
    'application/vnd.oasis.opendocument.text',
    'text/csv',
    'text/tab-separated-values',
    'application/vnd.oasis.opendocument.spreadsheet',
    'text/html',
    'application/xhtml+xml',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/svg+xml'
  ] 

    const validFiles = selectedFiles.filter((file) => allowedTypes.includes(file.type))
    this.uploadSequentially(validFiles)
  }

  uploadSequentially(files: File[]) {
    if (files.length === 0) {
      this.currentUploadName = null
      this.currentUploadProgress = 0
      return
    }

    const file = files.shift()
    if (!file) return

    this.currentUploadName = file.name
    this.currentUploadProgress = 0

    this.builderService
      .uploadPdf(file, this.builderService.selectedProject, true, (progress) => {
        this.currentUploadProgress = progress
      })
      .subscribe({
        next: (downloadUrl) => {
          this.documentUrls.push({ name: file.name, url: downloadUrl })
          this.uploadSequentially(files) // upload next
        },
        error: (err) => {
          console.error('Upload error:', err)
          this.uploadSequentially(files) // continue to next even if failed
        }
      })
  }

  /**
   * When the user drops files into the drop area.
   * Converts dropped files into a file input format and uploads them.
   */
  onDocumentDrop(event: DragEvent): void {
    event.preventDefault()
    this.dragOverDocs = false

    const files = event.dataTransfer?.files
    if (!files || files.length === 0) return

    const selectedFiles = Array.from(files)
    selectedFiles.forEach((file) => {
      const fakeEvent = { target: { files: [file] } }
      this.onDocumentSelected(fakeEvent)
    })
  }

  /**
   * Deletes a document from Firebase Storage and removes it from the local list.
   *
   * @param index - Index of the document in the documentUrls array
   */
  removePdf(index: number) {
    const file = this.documentUrls[index]
    if (!file || !file.url) return

    this.builderService.deleteDocument(file.url).subscribe({
      next: () => {
        this.documentUrls.splice(index, 1)
      },
      error: (err) => {
        console.error('Error removing file from storage:', err)
      }
    })
  }

  toggleShowAllDocs() {
    this.showAllDocuments = true
  }
  
getFileIcon(file: { name: string; url: string }): string {
  const ext = file.name.split('.').pop()?.toLowerCase() || '';
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];

  if (imageExtensions.includes(ext)) {
    return file.url;
  }

  switch (ext) {
    case 'pdf': return 'assets/images/products/pdf.png';
    case 'doc':
    case 'docx': return 'assets/images/products/doc.png';
    case 'xls':
    case 'xlsx': return 'assets/images/products/xls-file.png';
    case 'ppt':
    case 'pptx': return 'assets/images/products/ppt.png';
    case 'txt':
    case 'rtf': return 'assets/images/products/txt-file.png';
    case 'odt': return 'assets/images/products/doc.png';
    case 'ods': return 'assets/images/products/xls-file.png';
    case 'csv':
    case 'tsv': return 'assets/images/products/csv-file.png';
    case 'html':
    case 'htm': return 'assets/images/products/html.png';
    default: return 'assets/images/products/doc.png'; 
  }

  
}

  // ============================================
  // Custom Dropdown Methods
  // ============================================

  toStr(val: any): string {
    return String(val)
  }

  getOptionLabel(options: { value: string; label: string }[], value: any): string {
    if (!value || (Array.isArray(value) && value.length === 0)) return ''
    return options.find(o => o.value === value)?.label ?? String(value)
  }

  toggleDropdown(key: string, event: Event) {
    event.stopPropagation()
    const wasOpen = !!this.dropdownOpen[key]
    this.closeAllCustomDropdowns()
    this.dropdownOpen[key] = !wasOpen
  }

  selectOption(controlName: string, value: string, event: Event) {
    event.stopPropagation()
    this.productForm.get(controlName)?.setValue(value)
    this.dropdownOpen[controlName] = false
  }

  toggleCategoryDropdown(event: Event) {
    event.stopPropagation()
    const wasOpen = this.categoryDropdownOpen
    this.closeAllCustomDropdowns()
    this.categoryDropdownOpen = !wasOpen
  }

  toggleCategoryOption(catId: string, event: Event) {
    event.stopPropagation()
    const current: string[] = [...(this.productForm.get('categoriesIds')?.value || [])]
    const idx = current.indexOf(catId)
    if (idx >= 0) current.splice(idx, 1)
    else current.push(catId)
    this.productForm.get('categoriesIds')?.setValue(current)
    this.categoryChange(current)
  }

  isCategorySelected(catId: string): boolean {
    return (this.productForm.get('categoriesIds')?.value || []).includes(catId)
  }

  getSelectedCategoriesLabel(): string {
    const ids: string[] = this.productForm.get('categoriesIds')?.value || []
    if (!ids.length) return ''
    return this.categoriesService.allCategories
      .filter((c: any) => ids.includes(String(c.categoryId)))
      .map((c: any) => c.categoryName)
      .join(', ')
  }

  toggleSubCategoryDropdown(event: Event) {
    event.stopPropagation()
    const wasOpen = this.subCategoryDropdownOpen
    this.closeAllCustomDropdowns()
    this.subCategoryDropdownOpen = !wasOpen
  }

  toggleSubCategoryOption(subCatId: string, event: Event) {
    event.stopPropagation()
    const current: string[] = [...(this.productForm.get('subCategoriesIds')?.value || [])]
    const idx = current.indexOf(subCatId)
    if (idx >= 0) current.splice(idx, 1)
    else current.push(subCatId)
    this.productForm.get('subCategoriesIds')?.setValue(current)
    this.subCategoryChange(current as any)
  }

  isSubCategorySelected(subCatId: string): boolean {
    return (this.productForm.get('subCategoriesIds')?.value || []).includes(subCatId)
  }

  getSelectedSubCategoriesLabel(): string {
    const ids: string[] = this.productForm.get('subCategoriesIds')?.value || []
    if (!ids.length) return ''
    return this.allowedSubcategories
      .filter((s: any) => ids.includes(String(s.subCategoryId)))
      .map((s: any) => s.subcategory)
      .join(', ')
  }

  toggleCodeTypeDropdown(rowIdx: number, variationIdx: number | undefined, event: Event) {
    event.stopPropagation()
    const wasOpenSimple = variationIdx === undefined && !!this.codeTypeDropdownSimple[rowIdx]
    const wasOpenVar = variationIdx !== undefined && !!(this.codeTypeDropdownVariation[variationIdx]?.[rowIdx])
    this.closeAllCustomDropdowns()
    if (variationIdx === undefined) {
      this.codeTypeDropdownSimple[rowIdx] = !wasOpenSimple
    } else {
      if (!this.codeTypeDropdownVariation[variationIdx]) {
        this.codeTypeDropdownVariation[variationIdx] = []
      }
      this.codeTypeDropdownVariation[variationIdx][rowIdx] = !wasOpenVar
    }
  }

  selectCodeTypeOption(rowIdx: number, variationIdx: number | undefined, value: string, event: Event) {
    event.stopPropagation()
    this.onCodeTypeChange(rowIdx, variationIdx, value)
    if (variationIdx === undefined) {
      this.codeTypeDropdownSimple[rowIdx] = false
    } else if (this.codeTypeDropdownVariation[variationIdx]) {
      this.codeTypeDropdownVariation[variationIdx][rowIdx] = false
    }
  }

  @HostListener('document:click')
  closeAllCustomDropdowns() {
    this.dropdownOpen = {}
    this.categoryDropdownOpen = false
    this.subCategoryDropdownOpen = false
    this.codeTypeDropdownSimple = []
    this.codeTypeDropdownVariation = []
  }

  }
